import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import { TOrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SravniReviewsEnumsRatingType } from '../../__generated__/reviews/reviewsApiTypes';
import { MIN_APPROVED_COUNT } from '../../constants/rating';
import { ISravniRating } from '../../interfaces/ratings';
import { ICustomersRating, IProductRating, IServicesRating } from '../../interfaces/reviews';
import { getSravniRating } from '../../services/ratings';

interface IState {
  ratingSravni: ISravniRating[];
  servicesRating: IServicesRating[];
  productsRating: {
    [key: string]: IProductRating;
  };
}

const initialState: IState = {
  ratingSravni: null,
  servicesRating: null,
  productsRating: {},
};

const name = 'ratings';

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setRatingSravni: (state, { payload }: PayloadAction<ISravniRating[]>) => {
      state.ratingSravni = payload;
    },
    setServicesRating: (state, { payload }: PayloadAction<Partial<ICustomersRating[]>>) => {
      if (payload.length > 0) {
        state.servicesRating = payload.map(({ participantsCount, complexCalculatedRatingValue, reviewTag }) => ({
          participantsCount,
          rating: complexCalculatedRatingValue,
          reviewTag,
        }));
      }
    },
    setProductsRating: (state, { payload }: PayloadAction<IProductRating>) => {
      state.productsRating[payload.productId] = {
        // @ts-ignore
        participantsCount: payload.participantsCount,
        rating: payload.complexCalculatedRatingValue,
        reviewTag: payload.reviewTag,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSravniRating.fulfilled, (state, { payload }) => {
      state.ratingSravni = payload;
    });
  },
});

const { actions, reducer } = slice;

export const { setRatingSravni, setServicesRating, setProductsRating } = actions;

export const fetchSravniRating = createAsyncThunk<ISravniRating[], TOrganizationTypes>(
  `${name}/fetchSravniRating`,
  async (payload) => {
    const orgHelper = getOrganizationHelpers(payload);

    return await getSravniRating({
      OrganizationType: orgHelper.reviewService,
      ServiceTag: 'unknown',
      RatingType: SravniReviewsEnumsRatingType.Default,
      PageSize: 10,
      MinApprovedCount: MIN_APPROVED_COUNT[orgHelper.typeForService],
    });
  },
);

export default reducer;
